import React, { useState, useRef, useEffect } from 'react';
import { BsQuestionLg } from 'react-icons/bs';
import styles from './HelpFooter.module.css';
import UserGuide from './UserGuide/UserGuide';

const HelpFooter: React.FC = () => {
  const [expanded, setExpanded] = useState(false);
  const timerRef = useRef<NodeJS.Timeout | null>(null);

  // Collapse after 5 seconds of no interaction
  useEffect(() => {
    if (expanded) {
      timerRef.current = setTimeout(() => setExpanded(false), 3300);
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }
      };
    }
    return undefined;
  }, [expanded]);

  const clearCollapseTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
  };

  const startCollapseTimer = () => {
    clearCollapseTimer();
    timerRef.current = setTimeout(() => setExpanded(false), 3300);
  };

  const handleMouseEnter = () => {
    setExpanded(true);
    clearCollapseTimer();
  };

  const handleMouseLeave = () => {
    startCollapseTimer();
  };

  return (
    <div
      className={styles.fabContainer}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
    >
      <button
        className={styles.fabButton}
        aria-label="Open user guide menu"
        tabIndex={0}
      >
        <BsQuestionLg />
      </button>
      <UserGuide
        expanded={expanded}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
      />
    </div>
  );
};

export default HelpFooter; 